// src/elevarDataLayer.vbt.js
function addLoyaltyUserData() {
  const cachedLoyaltyData = JSON.parse(
    localStorage.getItem("muradUserLoyaltyData")
  );
  window.ElevarTransformFn = (item) => {
    if (item.event === "dl_user_data") {
      return {
        ...item,
        user_properties: {
          ...item.user_properties,
          loyalty: {
            loyalty_email: cachedLoyaltyData?.email,
            loyalty_created_at: cachedLoyaltyData?.created_at,
            // loyalty_status: cachedLoyaltyData?.isMember,
            loyalty_points_earned: cachedLoyaltyData?.pointsEarned,
            loyalty_points_balance: cachedLoyaltyData?.pointsBalance,
            loyalty_tier: cachedLoyaltyData?.vipTier
          }
        }
      };
    } else {
      return item;
    }
  };
}
function retrieveCacheLoyaltyData() {
  const cacheLoyaltyData = () => {
    const {
      email,
      created_at,
      isMember,
      vipTier,
      pointsEarned,
      pointsBalance
    } = window.Swell.Customer.getCustomerDetails();
    const loyaltyData = {
      email,
      created_at,
      // isMember,
      pointsEarned,
      pointsBalance,
      vipTier
    };
    localStorage.setItem("muradUserLoyaltyData", JSON.stringify(loyaltyData));
  };
  document.addEventListener("swell:setup", () => cacheLoyaltyData());
}
function handleElevarLoyalty() {
  addLoyaltyUserData();
  retrieveCacheLoyaltyData();
}
handleElevarLoyalty();
